import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"
import { up } from "styled-breakpoints"

const Logo = styled(Link)`
  display: block;
  position: ${props => props.position || "absolute"};
  height: 50px;
  z-index: 150;
  > div {
    margin: 1rem;
    height: 100%;
  }

  ${up("md")} {
    display: none;
  }
`

const LogoMobile = props => {
  return (
    <Logo to="/" position={props.position}>
      {props.slug === "kontakt" ? (
        <StaticImage
          src="../../../assets/images/logo/logo.png"
          alt="Logo="
          placeholder="blurred"
          layout="fixed"
          height={50}
        />
      ) : (
        <StaticImage
          src="../../../assets/images/logo/logo_white.png"
          alt="Logo="
          placeholder="blurred"
          layout="fixed"
          height={50}
        />
      )}
    </Logo>
  )
}
export default LogoMobile
